module.exports = __webpack_public_path__ + "static/media/ZugoLogo.ffb7de0a.webp";